import type { AxiosInstance } from 'axios';
import axios from 'axios';

export class ApiBaseService {
    protected readonly http: AxiosInstance;

    constructor(context: string) {
        this.http = axios.create({
            baseURL: context,
        });
    }
}
